module.exports = __webpack_public_path__ + "static/tales-51b2765f1f3e988b9af9d5de1bc61a9c.jpg";